import api from './api'
import { toast } from 'react-toastify'
import moment from 'moment'

export const getCancelComments = async (rangeDate) => {

  console.log('getCancelComments - rangeDate:', rangeDate)
  
  try {
    const url = 'subscriptions/cancel/comments'
    console.log('getCancelComments - URL:', url)
    console.log('getCancelComments - params:', {  rangeDate })
    
    const { data } = await api.get(url, {
      params: {
        rangeDate
      }
    })
    
    console.log('getCancelComments - response data:', data)
    return data || []
  } catch (error) {
    console.error('Erro ao buscar comentários de cancelamento:', error)
    console.error('Erro response:', error.response)
    console.error('Erro status:', error.response?.status)
    console.error('Erro data:', error.response?.data)
    toast.error('Erro ao carregar comentários de cancelamento', { theme: "colored" })
    return []
  }
}

// Função para converter período selecionado em rangeDate
export const getRangeDateFromPeriod = (period) => {
  const now = moment()
  console.log('getRangeDateFromPeriod - period:', period)
  console.log('getRangeDateFromPeriod - now:', now.format('YYYY-MM-DD'))
  
  let result
  switch (period) {
    case 'last-7-days':
      result = now.subtract(7, 'days').format('YYYY-MM-DD')
      break
    case 'last-30-days':
      result = now.subtract(30, 'days').format('YYYY-MM-DD')
      break
    case 'last-90-days':
      result = now.subtract(90, 'days').format('YYYY-MM-DD')
      break
    case 'all-period':
      result = '2020-01-01' // Data inicial do sistema
      break
    default:
      result = now.subtract(30, 'days').format('YYYY-MM-DD')
  }
  
  console.log('getRangeDateFromPeriod - result:', result)
  return result
}
